import { render, staticRenderFns } from "./TaskLabel.vue?vue&type=template&id=affb36f2&scoped=true&lang=pug&"
import script from "./TaskLabel.vue?vue&type=script&lang=js&"
export * from "./TaskLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb36f2",
  null
  
)

export default component.exports